var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18.028v3.337a.623.623 0 00.634.634h3.338c.333 0 .653-.133.89-.367L17.573 10.83a.634.634 0 000-.89l-3.57-3.56a.634.634 0 00-.88 0L2.367 17.139a1.268 1.268 0 00-.367.89zM21.63 5.04l-2.67-2.671a1.258 1.258 0 00-1.782 0l-1.335 1.335a.634.634 0 000 .89l3.562 3.562a.634.634 0 00.89 0l1.336-1.335a1.258 1.258 0 000-1.781z"
  })));
}
export default SvgEditIcon;